import React, { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import Metadata from '../layout/metadata'

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import AdminNavigation from '../layout/adminNavigation'
import { formatDate, numberWithCommas } from '../../Functions/functions'

import { useDispatch, useSelector } from 'react-redux'
import { getAllOrders, clearErrors } from '../../actions/orderActions'

let clicked = "All";
let firstLoad = true;

const AllOrders = () => {

    const dispatch = useDispatch();

    const { loading, error, orders } = useSelector(state => state.getOrders );

    let [ filteredOrders, setFilteredOrders ] = useState(orders)

    if (firstLoad) { filteredOrders = orders };

    useEffect(() => {
        dispatch(getAllOrders());

        if (error) {
            console.log(error, "ERRROORRRR!!")
            // alert.error(error);
            dispatch(clearErrors())
        }
    }, [dispatch, error])

    const onSearchChange = (e) => {
        if (e.target.value === "") {
            return setFilteredOrders(orders)
        }
        let matches = orders.filter(order => order._id.toLowerCase().includes(e.target.value.toLowerCase()))

        setFilteredOrders(matches);
        firstLoad = false;
    }

    const toggleTable = (status) => {
        firstLoad = false
        let filter
        clicked = status
        if (status === "All") {
            filter = orders;
        } else if (status === "Processing") {
            filter = orders.filter(order => order.orderStatus === "Processing")
        } else if (status === "Shipped") {
            filter = orders.filter(order => order.orderStatus === "Shipped")
        } else if (status === "Delivered") {
            filter = orders.filter(order => order.orderStatus === "Delivered")
        } else if (status === "Cancelled"){
            filter = orders.filter(order => order.orderStatus === "Cancelled")
        } else {
            filter = []
        }

        setFilteredOrders(filter)
    }

    const rowData = [];

    return (
        <Fragment>
            <Metadata title={"All Orders"}/>
            <AdminNavigation Orders/>
            <div className="container-fluid">
                <div className="container-md seller-section-box">
                    <div className="d-flex align-items-center mt-3">
                        <h3 className="text-2 text-muted d-inline-block m-0 me-4 bold-2">ORDERS</h3>
                        <div className="d-flex ms-auto align-items-center">
                            <input
                            className="form-control d-inline-block py-1" 
                            type="search" 
                            placeholder="Search orders"
                            aria-label="Search"
                            onChange={onSearchChange}
                            />
                        </div>
                    </div>

                    {/* FILTERS */}
                    <div className="d-flex flex-column flex-md-row justify-content-between mt-3">
                        <span className="text-muted text-2 order-1 order-md-2">{filteredOrders.length} {clicked === 'All' ? 'Orders' : clicked}</span>
                        <div className="table-nav-block order-2 order-md-1 mt-3 mt-md-0">
                            <button onClick={function() { toggleTable('All') }} className={`table-nav ms-0 ${clicked === 'All'?'table-active':''}`}>All</button>
                            <button onClick={function() { toggleTable('Processing') }} className={`table-nav ${clicked === 'Processing'?'table-active':''}`}>Processing</button>
                            <button onClick={function() { toggleTable('Shipped') }} className={`table-nav ${clicked === 'Shipped'?'table-active':''}`}>Shipped</button>
                            <button onClick={function() { toggleTable('Delivered') }} className={`table-nav ${clicked === 'Delivered'?'table-active':''}`}>Delivered</button>
                            <button onClick={function() { toggleTable('Cancelled') }} className={`table-nav ${clicked === 'Cancelled'?'table-active':''}`}>Cancelled</button>
                        </div>
                        
                    </div>
                        

                    {loading ? 
                        <Fragment>
                            <div className="my-4">
                                <Skeleton count={15} height={20} baseColor="#dc720082"/>
                            </div>
                        </Fragment> : (
                        <Fragment>

                        <table className="table mt-3">
                            <thead className="table-secondary py-5">
                                <tr>
                                    <th className="text-2" scope="col">OrderId</th>
                                    <th className="text-2" scope="col">No. of Items</th>
                                    <th className="text-2" scope="col">Order Amount</th>
                                    <th className="text-2" scope="col">Date ordered</th>
                                    <th className="text-2" scope="col">Payment method</th>
                                    <th className="text-2" scope="col">Status</th>
                                    <th className="text-2 text-center" scope="col">Action</th>
                                </tr>
                            </thead>

                            {filteredOrders.forEach(order => rowData.push(
                                <tr className="bg-white" key={order._id}>
                                    <td className="text-2 d-flex align-items-center">{order.new ? <span className="red-circle">🔴</span> : <Fragment></Fragment>}#{order._id}</td>
                                    <td className="text-2">{order.orderItems.length}</td>
                                    <td className="text-2">&#x20A6;{numberWithCommas(order.totalPrice)}</td>
                                    <td className="text-2">{formatDate(order.createdAt)}</td>
                                    <td className="text-2">{order.paymentMethod}</td>
                                    <td className={`text-2 ${order.orderStatus === 'Cancelled' ? 'red-color' : order.orderStatus === 'Delivered' ? 'green-color' : ''}`}>{order.orderStatus}</td>
                                    <td className="text-center text-2"><Link to={`/admin/orders/${order._id}`}className="table-btn">View</Link></td>
                                </tr>                                 
                            ))}
                            <tbody>{rowData}</tbody>
                        </table>
                        { filteredOrders.length == 0 ? (
                            <div className="text-center py-3 w-100">
                                <h3 className='text-2'>NO DATA</h3>
                            </div>
                        ):(<Fragment></Fragment>)}
                    </Fragment>
                    )}
                </div>
            </div>
            


        </Fragment>
    )
}

export default AllOrders